import React from "react";
import CommonNavbar from "../components/CommonNavbar/CommonNavbar";
import Wishlist from "../components/Wishlist/Wishlist";
import SubscribeNewsletter from "../components/Cart/SubscribeNewsletter";
import CommonFooter from "../components/CommonFooter/CommonFooter";

const Wishlists = () => {
  return (
    <div>
      <CommonNavbar hide_btn="d-none" show_btn="d-block" />
      <Wishlist />
      {/* <SubscribeNewsletter /> */}
      <CommonFooter />
    </div>
  );
};

export default Wishlists;
